export default __webpack_public_path__ + "static/media/vouchers.54b80ba3.svg";